import loadable from '@app/ui/components/LazyLoad';

const ConfirmModal: $TSFixMe = loadable(
  () => import(/* webpackChunkName: "lazy.confirmModal" */ './ConfirmModal'),
);

export default ConfirmModal;
